import type { TApplicationState, TFiltersState } from 'shared/types/redux';

export const selectFilters = (state: TApplicationState): TFiltersState => state.filters;
